// extracted by mini-css-extract-plugin
export var checkbox = "_s-0";
export var circle = "_s-3";
export var horizontalContainer = "_s-7";
export var sm = "_s-5";
export var switch0 = "_s-2";
export var switchDisabled = "_s-8";
export var switchEnabled = "_s-1";
export var textSwitchContainer = "_s-9";
export var textSwitchOption = "_s-a";
export var textSwitchOptionSelected = "_s-b";
export var verticalContainer = "_s-6";
export var xs = "_s-4";